import { AxiosAdapter } from "../commons/adapters";
import { QueryPagination } from "../commons/interfaces";
import { buildQuery } from "../commons/utils/helpers";
import { IAssistantsBackendRequestDto } from "../pages/inteligencia-artificial/asistentes/interfaces/IAssistantsBackend";

const http = new AxiosAdapter();
const BASE_URL = '/v1/assistants';

export const getAllAssistantsService = async (query?: QueryPagination) => {
    try {
        return await http.get<any>(`${BASE_URL}?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('getAllAssistantsService error', error);
    }
}

export const getAssistantsFormOptionsService = async () => {
    try {
        return await http.get<any>(`${BASE_URL}/form`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('getAssistantsFormOptionsService error', error);
    }
}

export const getAssistantByIdService = async (id: string) => {
    try {
        return await http.get<any>(`${BASE_URL}/${id}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('getAssistantByIdService error', error);
    }
}

export const createAssistantService = async (data: IAssistantsBackendRequestDto) => {
    try {
        return await http.post<any>(BASE_URL, data, null);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('createAssistantService error', error);
    }
}

export const updateAssistantService = async (id: string, data: IAssistantsBackendRequestDto) => {
    try {
        return await http.put<any>(`${BASE_URL}/${id}`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('updateAssistantService error', error);
    }
}

export const deleteAssistantService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.deleteTable<any>(`${BASE_URL}/${id}?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('deleteAssistantService error', error);
    }
}

export const restoreAssistantService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.patchTable<any>(`${BASE_URL}/${id}/restore?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.error('restoreAssistantService error', error);
    }
}
